import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import 'whatwg-fetch';
import VoucherModule from "./store/voucher";
import ProductsModule from "./store/products";
import RecyclableModule from "./components/_common/Recyclable/vuexstore";
import GiftWrappingModule from "./components/_common/GiftWrapping/vuexstore";
import DmGlamiConsentModule from "./components/_common/modules/dm_glami/vuexstore";
import DmZboziConsentModule from "./components/_common/modules/dm_zbozi/vuexstore";
import DmHeurekaV2Module from "./components/_common/modules/dm_heureka_v2/vuexstore";
import PdCeneoZaufaneOpinieProModule from "./components/_common/modules/pdceneozaufaneopiniepro/vuexstore";
import ShaimZboziCz from "@/components/_common/modules/shaim_zbozi_cz/vuexstore";
import Mergado from "@/components/_common/modules/mergado/vuexstore";
import Inputmask from 'inputmask'
import phonePrefixProvider from "@/phonePrefix";

Vue.directive('mask', {
    bind: function(el, binding) {
        Inputmask(binding.value).mask(el);
    },
    update: function (el, binding) {
        let newMask = binding.value;
        if (newMask === binding.oldValue) {
            return;
        }
        const currentValue = el.inputmask.unmaskedvalue();
        el.value = currentValue;
        const newInputmask = Inputmask(binding.value).mask(el);
        newInputmask.value = currentValue;
    }
});
/* IE11 forEach polyfill */
if ('NodeList' in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

/* IE11 remove polyfill */
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

function getBaseUri()
{
    if (window.base_uri) {
        return window.base_uri;
    }
    if (window.baseUri) {
        return window.baseUri;
    }
    if (window.prestashop.urls.base_url) {
        return window.prestashop.urls.base_url;
    }
}
window.base_uri = getBaseUri();

Vue.config.productionTip = false;
Vue.use(Vuex);

window.CofisCartEvent = new Vue({
    methods: {
        dispatch: function (event, data) {
            this.$emit(event, data);
            window.cofiscart.eventManager.dispatch(event, data);
        },
        on: function (event, callback) {
            this.$on(event, callback);
            window.cofiscart.eventManager.on(event, callback);
        }
    }
});

const BASE_URI = window.base_uri;
const MODULE_URL = 'modules/cofiscart';
const ENDPOINTS_FILE = MODULE_URL + '/cofiscartajax.php';

const store = new Vuex.Store({
    modules: {
        voucher: VoucherModule,
        products: ProductsModule,
        recyclable: RecyclableModule,
        giftWrapping: GiftWrappingModule,
        dmGlamiConsent: DmGlamiConsentModule,
        dmZboziConsent: DmZboziConsentModule,
        dmHeurekaV2: DmHeurekaV2Module,
        PdCeneoZaufaneOpiniePro: PdCeneoZaufaneOpinieProModule,
        shaimZboziCz: ShaimZboziCz,
        mergado: Mergado,
    },
    state: {
        initialLoading: true,
        defaultAddressesInitialized: false,
        translations: {},
        activeStep: 1,
        lockDeliveryPostalCode: false,
        config: {
            theme_settings: {
                step4layout: 'long',
                discount_block_position: '',
                total_price_excluded_position: '',
                total_tax_position: '',
                custom_unit_by_category: {},
                custom_calculation_by_category_and_attribute: {},
                registration_info: '',
                show_original_price: false,
                disable_quantity_input: false,
            },
            optional_address_fields: {
                delivery_address: {
                    show_company: 0,
                    company: 0,
                    identification_number: 0,
                    tax_identification_number: 0,
                },
                invoice_address: {
                    phone: 0,
                    company: 0,
                    identification_number: 0,
                    tax_identification_number: 0,
                    first_name: 0,
                    last_name: 0,
                }
            },
            quantity_controls_active: false,
            use_vat: true,
            allow_login_in_cart: true,
            allow_registration_in_cart: true,
            show_voucher_field_by_default: true,
            change_currency_on_country_change: true,
            trim_product_name: true,
            show_free_delivery: true,
            countries: [],
            default_country: 0,
            consents: {
                type: 'text',
                terms_of_use: {
                    link: null,
                    name: null,
                },
                privacy_policy: {
                    link: null,
                    name: null,
                }
            },
            currency_link: '',
            pickupDateDelay: 14,
            custom_message_active: false,
            custom_message: '',
            invoice_address_selector: false,
            delivery_address_selector: false,
            order_info: '',
            payments_need_reload: [],
            minimal_purchase_required: '',
            newsletter_enabled: false,
        },
        contact: {
            display: false,
            html: '',
        },
        currency: null,
        isLoggedIn: false,
        summary: {
            total_products_tax: 0,
            formattedPrices: {
                total_products_tax: '',
            }
        },
        rounding: 0,
        roundingSK: 0,
        formattedRounding: '',
        freeGift: {
            title: '',
            image: '',
            percent: 0,
        },
        accessories: [],
        randomProducts: [],
        crossSellingProducts: [],
        products: [],
        carriers: [],
        selectedCarrier: null,
        currentCarrier: null,
        packetery: {
            id: null,
            name: null,
            currency: null
        },
        packetery_v213: {
            id: null,
            name: null,
            currency: null,
            pickupPointType: null,
            carrierId: null,
            carrierPickupPointId: null,
            prestashopCarrierId: null,
        },
        shaim_zasilkovna_widget: {
            id: null,
            name: null,
            currency: null
        },
        packageForPostOffice: {
            search: {
                postalCode: '',
                city: '',
            },
            selectedPostOffice: {
                id: null,
                name: null,
            },
            postOffices: {},
        },
        dpdParcelShop: {
            searchQuery: '',
            selected: {
                id: null,
                name: null,
            },
            result: {},
        },
        wedoParcelShop: {
            searchQuery: '',
            selected: {
                id: null,
                name: null,
            },
            result: {},
        },
        glsParcelShop: {
            searchQuery: '',
            selected: {
                id: null,
                name: null,
            },
            result: {},
        },
        shaimBalikovna: {
            searchQuery: '',
            selected: {
                id: null,
                psc: null,
            },
            result: {},
        },
        shaimBalikNaPostu: {
            searchQuery: '',
            selected: {
                id: null,
                psc: null,
            },
            result: {},
        },
        shaimAio: {
            zbozi: false,
        },
        allPayments: [],
        payments: [],
        paymentExtensions: [],
        paymentMethodThumbnails: [],
        currentPayment: null,
        carriersPaymentsMap: {},
        selectedPayment: null,
        paymentHooks: '',
        shipmentWithPayment: {
            price: 0,
            formattedPrice: ''
        },
        freeDelivery: {
            condition: null,
            conditionFormatted: null,
            remaining: null,
            remainingFormatted: null,
            percent: null,
            percentFormatted: null,
        },
        orderNote: '',
        user: {
            defaultDeliveryAddressId: 0,
            defaultInvoiceAddressId: 0,
            deliveryAddressId: 0,
            invoiceAddressId: 0,
            addresses: [],
            password: '',
            newsletter: false,
            optin: false,
            deliveryAddress: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                phonePrefix: '',
                addressLine1: '',
                city: '',
                country: '',
                state: '',
                postalCode: '',
                company: '',
                identificationNumber: '',
                taxIdentificationNumber: '',
                additionalInformation: '',
            },
            showCompanyInformation: false,
            differentInvoiceAddress: false,
            invoiceAddress: {
                firstname: '',
                lastname: '',
                phone: '',
                phonePrefix: '',
                addressLine1: '',
                city: '',
                country: '',
                state: '',
                postalCode: '',
                company: '',
                identificationNumber: '',
                taxIdentificationNumber: '',
                taxIdentificationNumberState: '',
                additionalInformation: '',
            },
            requestRegistration: false,
            loginErrors: {
                email: '',
                password: '',
            },
            errors: {
                deliveryAddress: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    addressLine1: '',
                    city: '',
                    country: '',
                    state: '',
                    postalCode: '',
                    company: '',
                    identificationNumber: '',
                    taxIdentificationNumber: '',
                    additionalInformation: '',
                },
                invoiceAddress: {
                    firstname: '',
                    lastname: '',
                    phone: '',
                    addressLine1: '',
                    city: '',
                    country: '',
                    state: '',
                    postalCode: '',
                    company: '',
                    identificationNumber: '',
                    taxIdentificationNumber: '',
                    additionalInformation: '',
                },
                password: '',
            },
        },
        consents: {
            termsOfService: false,
            privacyPolicy: false,
            customerSatisfactionSurvey: false,
            independentShopRating: false,
            psEmailSubscription: false,
            errors: {
                termsOfService: '',
                privacyPolicy: '',
                customerSatisfactionSurvey: '',
                independentShopRating: '',
                psEmailSubscription: '',
            },
        },
        errors: {
            loginCountryMismatch: false,
        },
        pickupDate: '',
        additionalShippingCosts: 0,
        additionalShippingCostsFormatted: '',
    },
    getters: {
        hasUserError: state => {
            let hasError = null;
            hasError = function (obj) {
                let result = false;
                Object.entries(obj).forEach(entry => {
                    if (result === true) {
                        return;
                    }
                    if (entry[1] !== null && typeof entry[1] === 'object') {
                        result = hasError(entry[1]);
                        return;
                    }
                    result = entry[1] !== '';
                });
                return result;
            };

            return hasError(state.user.errors);
        },
        hasRegistrationError: state => {
            let hasError = null;
            hasError = function (obj) {
                let result = false;
                Object.entries(obj).forEach(entry => {
                    if (result === true) {
                        return;
                    }
                    if (entry[0] === 'login') {
                        return;
                    }
                    if (entry[1] !== null && typeof entry[1] === 'object') {
                        result = hasError(entry[1]);
                        return;
                    }
                    result = entry[1] !== '';
                });
                return result;
            };

            return hasError(state.user.errors);
        },
        containsVirtualProduct: state => {
            if (state.products.length === 0) {
                return false;
            }
            return state.products.filter(product => product.is_virtual).length > 0;
        }
    },
    actions: {
        AJAX_POST: ({}, {action, data}) => {
            const formData = new FormData();
            for ( let key in data ) {
                formData.append(key, data[key]);
            }
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=' + action + '&t=' + new Date().getTime(), {
                method: 'POST',
                body: formData,
                credentials: "include",
            }).then(function (response) {
                return response.json();
            });
        },
        USER_LOGIN: ({commit, dispatch, state}, {email, password}) => {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);
            const selectedCountry = state.user.deliveryAddress.country;

            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=login' + '&t=' + new Date().getTime(), {
                method: 'POST',
                body: formData,
                credentials: "include",
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (data.result !== 'OK') {
                    commit('SET_USER_LOGIN_EMAIL_ERROR', data.messages.email);
                    commit('SET_USER_LOGIN_PASSWORD_ERROR', data.messages.password);
                } else {
                    commit('SET_USER_LOGIN_EMAIL_ERROR', '');
                    commit('SET_USER_LOGIN_PASSWORD_ERROR', '');

                    return dispatch('SYNC_STATE');
                }
            }).then(() => {
                if (parseInt(state.user.deliveryAddress.country) !== parseInt(selectedCountry)) {
                    return dispatch('LOAD_CARRIERS_AND_PAYMENTS').then(function () {
                        return Promise.all([dispatch('SELECT_CARRIER', null), dispatch('SELECT_PAYMENT', null)])
                            .then(() => {
                                commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', true);
                                commit('SET_ACTIVE_STEP', 2);
                            })
                    })
                }
            });
        },
        /* RESTRUCTURED PRODUCT */
        REMOVE_PRODUCT: ({ dispatch }, product) => {
            /* @deprecated */
            dispatch('products/REMOVE', {
                id: product.id,
                id_attribute: product.id_attribute
            });
        },
        SET_PRODUCT_QUANTITY: ({dispatch}, {product, quantity}) => {
            /* @deprecated */
            dispatch('products/SET_QUANTITY', {
                id: product.id,
                id_attribute: product.id_attribute,
                quantity: quantity,
                cart_quantity: product.cart_quantity
            });
        },
        INCREASE_PRODUCT_QUANTITY: ({dispatch}, product) => {
            /* @deprecated */
            dispatch('products/INCREASE_QUANTITY', {
                id: product.id,
                id_attribute: product.id_attribute
            })
        },
        DECREASE_PRODUCT_QUANTITY: ({dispatch}, product) => {
            /* @deprecated */
            dispatch('products/DECREASE_QUANTITY', {
                id: product.id,
                id_attribute: product.id_attribute
            })
        },

        /* PRODUCT */
        ADD_PRODUCT: ({dispatch}, product) => {
            /* @deprecated */
            dispatch('products/INCREASE_QUANTITY', {
                id: product.id,
                id_attribute: product.id_attribute
            });
        },
        DECREASE_QUANTITY: ({dispatch}, product) => {
            /* @deprecated */
            dispatch('products/DECREASE_QUANTITY', {
                id: product.id,
                id_attribute: product.id_attribute
            })
        },
        DELETE_PRODUCT: ({dispatch}, product) => {
            /* @deprecated */
            dispatch('products/REMOVE', {
                id: product.id,
                id_attribute: product.id_attribute
            });
        },
        /* CARRIERS */
        SET_CARRIERS_PAYMENT_MAP: ({commit}, data) => {
            commit('SET_CARRIERS_PAYMENT_MAP', data);
            commit('CALCULATE_PAYMENTS');
        },
        SELECT_CARRIER: ({commit, dispatch, state}, carrier) => {
            document.querySelectorAll('.cc-carrier').forEach(item => {
                item.classList.remove('cc-invalid')
            });
            if (carrier === null) {
                commit('SET_SHAIM_BALIKOVNA_SELECTED_POST_OFFICE', {id: null, psc: null, name: null});
                commit('SET_SHAIM_BALIKNAPOSTU_SELECTED_POST_OFFICE', {id: null, psc: null, name: null});
                commit('SET_SHAIM_ZASILKOVNA_WIDGET', {id: null, name: null, currency: null});
                commit('SET_GLS_PARCEL_SHOP_SELECTED_POST_OFFICE', {id: null, name: null});
                commit('SET_DPD_PARCEL_SHOP_SELECTED_POST_OFFICE', {id: null, name: null});
                commit('SET_PACKAGE_FOR_POST_OFFICE_SELECTED_POST_OFFICE', {id: null, name: null});
                commit('SET_PACKETERY', {id: null, name: null, currency: null});
                commit('SET_PACKETERY_V213', {id: null, name: null, currency: null, pickupPointType: null, carrierId: null, carrierPickupPointId: null, prestashopCarrierId: null});
            }
            commit('SET_USER_REQUEST_REGISTRATION', false);

            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=selectCarrier&carrier=' + encodeURIComponent(carrier) + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    if (data.result === 'OK') {
                        commit('SELECT_CARRIER', carrier);
                        commit('CALCULATE_PAYMENTS');
                        commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', false);

                        if (
                            state.config.modules && state.config.modules.dm_cashondelivery && state.config.modules.dm_cashondelivery.enabled
                            || (
                                state.config.payments_need_reload.length > 0 &&
                                state.payments.find(item => state.config.payments_need_reload.includes(item.name) && item.active)
                            )
                        ) {
                            const body = document.getElementsByTagName('body')[0];
                            const coverSpin = document.createElement('div');
                            coverSpin.id = 'cart-cover-spin';
                            body.appendChild(coverSpin);
                            dispatch('LOAD_CARRIERS_AND_PAYMENTS')
                                .then(() => {
                                    document.getElementById('cart-cover-spin').remove();
                                });
                        }
                        dispatch('UPDATE_SHIPMENT_WITH_PAYMENT_PRICE');
                        dispatch('SYNC_SUMMARY');
                    } else {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    return data;
                });
        },
        UPDATE_SHIPMENT_WITH_PAYMENT_PRICE: ({ commit, state }) => {
            let price = 0;
            if (state.currentCarrier) {
                price += parseFloat(state.currentCarrier.price)
            }
            if (state.currentPayment) {
                price += parseFloat(state.currentPayment.price)
            }
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + price, {credentials: "include"})
                .then((response) => {
                    return response.json();
                }).then((data) => {
                commit('SET_SHIPMENT_WITH_PAYMENT_PRICE', {
                    price: price,
                    formattedPrice: data.result
                });
            })
        },
        /* PAYMENTS */
        SELECT_PAYMENT: ({ commit, dispatch }, name) => {
            document.querySelectorAll('.cc-payment').forEach(item => {
                item.classList.remove('cc-invalid')
            });
            commit('SELECT_PAYMENT', name);
            commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', false);
            return Promise.all([
                dispatch('UPDATE_SHIPMENT_WITH_PAYMENT_PRICE'),
                dispatch('SYNC_SUMMARY'),
            ])
        },
        SET_PAYMENTS: ({commit}, data) => {
            commit('SET_PAYMENTS', data);
            commit('CALCULATE_PAYMENTS');
        },
        UPDATE_PACKETERY: ({ commit }, data) => {
            commit('SET_PACKETERY', data);
            const formData = new FormData();
            formData.append('id_branch', data.id);
            formData.append('name_branch', data.name);
            formData.append('currency_branch', data.currency);
            return fetch(BASE_URI + 'modules/packetery/ajax.php', {
                method: 'POST',
                body: formData,
                credentials: "include"
            })
        },
        UPDATE_PACKETERY_V213: ({ commit }, data) => {
            commit('SET_PACKETERY_V213', data);
            const formData = new FormData();
            formData.append('id_branch', data.id);
            formData.append('name_branch', data.name);
            formData.append('currency_branch', data.currency);
            formData.append('prestashop_carrier_id', data.prestashopCarrierId);
            formData.append('pickup_point_type', data.pickupPointType);
            formData.append('carrier_pickup_point_id', data.carrierPickupPointId);
            formData.append('id_carrier', data.prestashopCarrierId);
            formData.append('action', 'widgetsaveorderbranch');
            formData.append('token', window.prestashop.static_token);
            return fetch(BASE_URI + 'modules/packetery/ajax_front.php', {
                method: 'POST',
                body: formData,
                credentials: "include"
            })
        },
        UPDATE_SHAIM_ZASILKOVNA_WIDGET: ({ commit, state }, data) => {
            commit('SET_SHAIM_ZASILKOVNA_WIDGET', data);
            const formData = new FormData();
            var sour_x, sour_y;
            if (typeof data.gps != 'undefined' && data.gps.lat != 'undefined') {
                sour_x = data.gps.lat;
            } else {
                sour_x = data.latitude;
            }

            if (typeof data.gps != 'undefined' && data.gps.lon != 'undefined') {
                sour_y = data.gps.lon;
            } else {
                sour_y = data.longitude;
            }

            formData.append('id_cart', state.config.id_cart);
            formData.append('id', data.id);
            formData.append('place', data.place);
            formData.append('psc', data.zip);
            formData.append('street', data.street);
            formData.append('city', data.city);
            formData.append('country', data.country);
            formData.append('sour_x', sour_x);
            formData.append('sour_y', sour_y);
            formData.append('pondeli_rano_od', data.openingHours.regular.monday);
            formData.append('utery_rano_od', data.openingHours.regular.tuesday);
            formData.append('streda_rano_od', data.openingHours.regular.wednesday);
            formData.append('ctvrtek_rano_od', data.openingHours.regular.thursday);
            formData.append('patek_rano_od', data.openingHours.regular.friday);
            formData.append('sobota_rano_od', data.openingHours.regular.saturday);
            formData.append('nedele_rano_od', data.openingHours.regular.sunday);
            formData.append('link', data.url);
            data.photos.forEach((item, index) => {
                formData.append('picture['+index+'][normal]', item['normal']);
                formData.append('picture['+index+'][thumbnail]', item['thumbnail']);
            })
            formData.append('pay_by_card', data.creditCardPayment);
            formData.append('id_customer', state.config.id_customer);
            formData.append('submit_message', 1);
            formData.append('secure_key', data.secret_key);
            formData.append('pickupPointType', data.pickupPointType);
            formData.append('carrierId', data.carrierId);
            formData.append('carrierPickupPointId', data.carrierPickupPointId);
            formData.append('claimAssistant', data.claimAssistant);
            formData.append('currency', data.currency.toUpperCase());
            formData.append('directions', data.directions);
            formData.append('maxWeight', data.maxWeight);
            formData.append('packetConsignment', data.packetConsignment);
            formData.append('routingCode', data.routingCode);
            formData.append('routingName', data.routingName);

            return fetch(BASE_URI + 'modules/shaim_zasilkovna_widget/hledat_zasilkovna_widget_ajax.php', {
                method: 'POST',
                body: formData,
                credentials: "include"
            })
        },
        /* USER */
        VALIDATE_USER_FIELD: ({commit}, url) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + url, {credentials: "include"})
                .then(response => {
                    return response.json();
                });
        },
        UPDATE_FIRSTNAME: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.firstname === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_FIRSTNAME', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateFirstname&firstname=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_FIRSTNAME_ERROR', data.message);
                    } else {
                        commit('SET_USER_FIRSTNAME_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_LASTNAME: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.lastname === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_LASTNAME', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateLastname&lastname=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_LASTNAME_ERROR', data.message);
                    } else {
                        commit('SET_USER_LASTNAME_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_COMPANY: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.delivery_address.company) === 1
                && value.trim() === ''
                && state.user.deliveryAddress.company === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.deliveryAddress.company === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_COMPANY', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateCompany&company=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_COMPANY_ERROR', data.message);
                    } else {
                        commit('SET_USER_COMPANY_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_IDENTIFICATION_NUMBER: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.delivery_address.identification_number) === 1
                && value.trim() === ''
                && state.user.deliveryAddress.identificationNumber === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.deliveryAddress.identificationNumber === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_IDENTIFICATION_NUMBER', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateIdentificationNumber&number=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_IDENTIFICATION_NUMBER_ERROR', data.message);
                    } else {
                        commit('SET_USER_IDENTIFICATION_NUMBER_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_TAX_IDENTIFICATION_NUMBER: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.delivery_address.tax_identification_number) === 1
                && value.trim() === ''
                && state.user.deliveryAddress.taxIdentificationNumber === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.deliveryAddress.taxIdentificationNumber === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_TAX_IDENTIFICATION_NUMBER', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateTaxIdentificationNumber&number=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_TAX_IDENTIFICATION_NUMBER_ERROR', data.message);
                    } else {
                        commit('SET_USER_TAX_IDENTIFICATION_NUMBER_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_EMAIL: ({commit, dispatch}, value) => {
            commit('SET_USER_EMAIL', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateEmail&email=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_EMAIL_ERROR', data.message);
                    } else {
                        commit('SET_USER_EMAIL_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_PASSWORD: ({commit, dispatch}, value) => {
            commit('SET_USER_PASSWORD', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validatePassword&password=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_PASSWORD_ERROR', data.message);
                    } else {
                        commit('SET_USER_PASSWORD_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_ADDRESS_LINE_1: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.addressLine1 === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_ADDRESS_LINE_1', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateAddressLine1&address=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_ADDRESS_LINE_1_ERROR', data.message);
                    } else {
                        commit('SET_USER_ADDRESS_LINE_1_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_CITY: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.city === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_CITY', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateCity&city=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_CITY_ERROR', data.message);
                    } else {
                        commit('SET_USER_CITY_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_COUNTRY: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.country === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_COUNTRY', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            const url = '?action=updateCountry&id_country='+value+'&t=' + new Date().getTime();
            return fetch(BASE_URI + ENDPOINTS_FILE + url, {credentials: "include"})
                .then(response => {
                    return response.json();
                }).then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_COUNTRY_ERROR', data.message);
                    } else {
                        commit('SET_USER_COUNTRY_ERROR', '');
                    }

                    if (state.config.change_currency_on_country_change) {
                        const country = state.config.countries.find((country) => {
                            return parseInt(country.id) === parseInt(value);
                        });
                        if (parseInt(state.config.currency) !== parseInt(country.id_currency)) {
                            fetch(state.config.currency_link + '?SubmitCurrency=1&id_currency='+country.id_currency)
                                .then(() => {
                                    window.location.reload();
                                })
                        }
                    }

                    return {data, state};
                }).then(({data, state}) => {
                    const selectedCarrier = state.selectedCarrier;
                    const selectedPayment = state.selectedPayment;
                    Promise.all([dispatch('SYNC_STATE'), dispatch('LOAD_CARRIERS_AND_PAYMENTS')]).then(function () {
                        if (selectedCarrier !== null || selectedPayment !== null) {
                            commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', true);
                        } else {
                            commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', false);
                        }
                        if (state.user.deliveryAddress.postalCode && state.user.deliveryAddress.postalCode.length > 0) {
                            dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode);
                        }

                        if (state.user.deliveryAddress.taxIdentificationNumber && state.user.deliveryAddress.taxIdentificationNumber.length > 0) {
                            dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber);
                        }
                    });

                    return data;
                });
        },
        UPDATE_COUNTRY_NO_SYNC: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.country === value && value !== 0) {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_COUNTRY', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateCountry&code=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_COUNTRY_ERROR', data.message);
                    } else {
                        commit('SET_USER_COUNTRY_ERROR', '');
                    }

                    if (state.user.deliveryAddress.postalCode && state.user.deliveryAddress.postalCode.length > 0) {
                        dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode);
                    }

                    if (state.user.showCompanyInformation && state.user.deliveryAddress.taxIdentificationNumber && state.user.deliveryAddress.taxIdentificationNumber.length > 0) {
                        dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber);
                    }

                    return data;
                });
        },
        UPDATE_STATE: ({commit, dispatch, state}, value) => {
            commit('SET_USER_STATE', value);
        },
        UPDATE_POSTAL_CODE: ({commit, dispatch, state}, value) => {
            value = String(value);
            if (state.user.deliveryAddress.postalCode === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_POSTAL_CODE', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validatePostalCode&code=' + encodeURIComponent(value) + '&country=' + encodeURIComponent(state.user.deliveryAddress.country) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_POSTAL_CODE_ERROR', data.message);
                    } else {
                        commit('SET_USER_POSTAL_CODE_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_PHONE: ({commit, dispatch, state}, value) => {
            const phonePrefix = phonePrefixProvider.getPhonePrefix(state.user.deliveryAddress.country);
            const cleanValue = value.replace(phonePrefix, '');
            if (state.user.deliveryAddress.phone === cleanValue && cleanValue.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_PHONE', value);
            commit('SET_DELIVERY_ADDRESS_ID', 0);
            return dispatch('VALIDATE_USER_FIELD', '?action=validatePhone&phone=' + encodeURIComponent(cleanValue) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_PHONE_ERROR', data.message);
                    } else {
                        commit('SET_USER_PHONE_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_DELIVERY_ADDRESS_PHONE_PREFIX: ({commit}, value) => {
            commit('SET_USER_PHONE_PREFIX', value);
        },
        UPDATE_INVOICE_ADDRESS_PHONE_PREFIX: ({commit}, value) => {
            commit('SET_USER_INVOICE_PHONE_PREFIX', value);
        },
        UPDATE_ADDITIONAL_INFORMATION: ({commit, dispatch, state}, value) => {
            if (state.user.deliveryAddress.additionalInformation === value) {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_USER_ADDITIONAL_INFORMATION', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateAdditionalInformation&additionalInformation=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_ADDITIONAL_INFORMATION_ERROR', data.message);
                    } else {
                        commit('SET_USER_ADDITIONAL_INFORMATION_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_FIRSTNAME: ({commit, dispatch, state}, value) => {
            if (
              parseInt(state.config.optional_address_fields.invoice_address.first_name) === 1
              && value.trim() === ''
              && state.user.invoiceAddress.firstname === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.invoiceAddress.firstname === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_FIRSTNAME', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceFirstname&firstname=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_FIRSTNAME_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_FIRSTNAME_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_LASTNAME: ({commit, dispatch, state}, value) => {
            if (
              parseInt(state.config.optional_address_fields.invoice_address.last_name) === 1
              && value.trim() === ''
              && state.user.invoiceAddress.lastname === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.invoiceAddress.lastname === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_LASTNAME', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceLastname&lastname=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_LASTNAME_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_LASTNAME_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_COMPANY: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.invoice_address.company) === 1
                && value.trim() === ''
                && state.user.invoiceAddress.company === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.invoiceAddress.company === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_COMPANY', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceCompany&company=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_COMPANY_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_COMPANY_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_IDENTIFICATION_NUMBER: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.invoice_address.identification_number) === 1
                && value.trim() === ''
                && state.user.invoiceAddress.identificationNumber === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.invoiceAddress.identificationNumber === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_IDENTIFICATION_NUMBER', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceIdentificationNumber&number=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_IDENTIFICATION_NUMBER_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_IDENTIFICATION_NUMBER_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER: ({commit, dispatch, state}, value) => {
            let force;
            let number;
            if (typeof value === 'string' || value instanceof String) {
                force = false;
                number = value;
            } else {
                force = value.force;
                number = value.taxIdentificationNumber;
            }
            if (
                parseInt(state.config.optional_address_fields.invoice_address.tax_identification_number) === 1
                && number.trim() === ''
                && state.user.invoiceAddress.taxIdentificationNumber === number
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (force === false && state.user.invoiceAddress.taxIdentificationNumber === number && number.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER', number);
            commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', 'loading');
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceTaxIdentificationNumber&number=' + encodeURIComponent(number) + '&country='+ encodeURIComponent(state.user.invoiceAddress.country) +'&t=' + new Date().getTime())
                .then(data => {
                    let promises = [];
                    if (data.result === 'vies_valid' || data.result === 'vies_valid_with_tax') {
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR', '');
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', data.result);
                        promises.push(dispatch('UPDATE_ADDRESSES'))
                    } else if (data.result === 'vies_invalid') {
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR', data.message);
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', data.result);
                    } else if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR', data.message);
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', '');
                    } else {
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR', '');
                        commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', '');
                        promises.push(dispatch('UPDATE_ADDRESSES'))
                    }
                    return Promise.all(promises);
                });
        },
        UPDATE_INVOICE_ADDRESS_LINE_1: ({commit, dispatch, state}, value) => {
            if (state.user.invoiceAddress.addressLine1 === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_ADDRESS_LINE_1', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceAddressLine1&address=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_ADDRESS_LINE_1_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_ADDRESS_LINE_1_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_CITY: ({commit, dispatch, state}, value) => {
            if (state.user.invoiceAddress.city === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_CITY', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceCity&city=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_CITY_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_CITY_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_COUNTRY: ({commit, dispatch, state}, value) => {
            if (state.user.invoiceAddress.country === value && value !== 0) {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_COUNTRY', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoiceCountry&code=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_COUNTRY_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_COUNTRY_ERROR', '');
                    }

                    if (state.user.invoiceAddress.postalCode && state.user.invoiceAddress.postalCode.length > 0) {
                        dispatch('UPDATE_INVOICE_POSTAL_CODE', state.user.invoiceAddress.postalCode);
                    }

                    if (state.user.invoiceAddress.taxIdentificationNumber && state.user.invoiceAddress.taxIdentificationNumber.length > 0) {
                        dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', {
                            taxIdentificationNumber: state.user.invoiceAddress.taxIdentificationNumber,
                            force: true,
                        });
                    }

                    return data;
                })
        },
        UPDATE_INVOICE_STATE: ({commit, dispatch, state}, value) => {
            commit('SET_USER_INVOICE_STATE', value);
        },
        UPDATE_INVOICE_POSTAL_CODE: ({commit, dispatch, state}, value) => {
            value = String(value);
            if (state.user.invoiceAddress.postalCode === value && value.trim() !== '') {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_POSTAL_CODE', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoicePostalCode&code=' + encodeURIComponent(value) + '&country=' + encodeURIComponent(state.user.invoiceAddress.country) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_POSTAL_CODE_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_POSTAL_CODE_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_PHONE: ({commit, dispatch, state}, value) => {
            if (
                parseInt(state.config.optional_address_fields.invoice_address.phone) === 1
                && value.trim() === ''
                && state.user.invoiceAddress.phone === value
            ) {
                // pole neni povinne a je prazdne
                return new Promise(resolve => { resolve(); });
            }
            if (state.user.invoiceAddress.phone === value && value.trim() !== '') {
                // hodnota se nezmenila, ale nesmi byt prazdna (pole je povinne)
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_PHONE', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateInvoicePhone&phone=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_PHONE_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_PHONE_ERROR', '');
                    }

                    return data;
                });
        },
        UPDATE_INVOICE_ADDITIONAL_INFORMATION: ({commit, dispatch, state}, value) => {
            if (state.user.invoiceAddress.additionalInformation === value) {
                return new Promise(resolve => { resolve(); });
            }
            commit('SET_INVOICE_ADDRESS_ID', 0);
            commit('SET_USER_INVOICE_ADDITIONAL_INFORMATION', value);
            return dispatch('VALIDATE_USER_FIELD', '?action=validateAdditionalInformation&additionalInformation=' + encodeURIComponent(value) + '&t=' + new Date().getTime())
                .then(data => {
                    if (data.result !== 'OK') {
                        commit('SET_USER_INVOICE_ADDITIONAL_INFORMATION_ERROR', data.message);
                    } else {
                        commit('SET_USER_INVOICE_ADDITIONAL_INFORMATION_ERROR', '');
                    }

                    return data;
                });
        },
        VALIDATE_WHOLE_USER: ({state, dispatch, getters}) => {
            let promises = [
                dispatch('UPDATE_FIRSTNAME', state.user.deliveryAddress.firstname),
                dispatch('UPDATE_LASTNAME', state.user.deliveryAddress.lastname),
                dispatch('UPDATE_EMAIL', state.user.deliveryAddress.email),
                dispatch('UPDATE_PHONE', state.user.deliveryAddress.phone),
            ];

            if (state.currentCarrier && state.currentCarrier.pickupInStore === false) {
                promises.push(dispatch('UPDATE_ADDRESS_LINE_1', state.user.deliveryAddress.addressLine1));
                promises.push(dispatch('UPDATE_CITY', state.user.deliveryAddress.city));
                promises.push(dispatch('UPDATE_COUNTRY_NO_SYNC', state.user.deliveryAddress.country));
                promises.push(dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode));

                if (state.user.showCompanyInformation) {
                    promises.push(dispatch('UPDATE_IDENTIFICATION_NUMBER', state.user.deliveryAddress.identificationNumber));
                    promises.push(dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber));
                }
                if (state.user.showCompanyInformation || state.config.optional_address_fields.delivery_address.show_company) {
                    promises.push(dispatch('UPDATE_COMPANY', state.user.deliveryAddress.company));
                }

                promises.push(dispatch('UPDATE_ADDITIONAL_INFORMATION', state.user.deliveryAddress.additionalInformation));
            } else if (!state.currentCarrier) {
                promises.push(dispatch('UPDATE_ADDRESS_LINE_1', state.user.deliveryAddress.addressLine1));
                promises.push(dispatch('UPDATE_CITY', state.user.deliveryAddress.city));
                promises.push(dispatch('UPDATE_COUNTRY_NO_SYNC', state.user.deliveryAddress.country));
                promises.push(dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode));

                if (state.user.showCompanyInformation) {
                    promises.push(dispatch('UPDATE_IDENTIFICATION_NUMBER', state.user.deliveryAddress.identificationNumber));
                    promises.push(dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber));
                }
                if (state.user.showCompanyInformation || state.config.optional_address_fields.delivery_address.show_company) {
                    promises.push(dispatch('UPDATE_COMPANY', state.user.deliveryAddress.company));
                }

                promises.push(dispatch('UPDATE_ADDITIONAL_INFORMATION', state.user.deliveryAddress.additionalInformation));
            }

            if (state.user.differentInvoiceAddress) {
                promises.push(dispatch('UPDATE_INVOICE_FIRSTNAME', state.user.invoiceAddress.firstname));
                promises.push(dispatch('UPDATE_INVOICE_LASTNAME', state.user.invoiceAddress.lastname));
                promises.push(dispatch('UPDATE_INVOICE_COMPANY', state.user.invoiceAddress.company));
                promises.push(dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', state.user.invoiceAddress.identificationNumber));
                promises.push(dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', state.user.invoiceAddress.taxIdentificationNumber));
                promises.push(dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', state.user.invoiceAddress.addressLine1));
                promises.push(dispatch('UPDATE_INVOICE_CITY', state.user.invoiceAddress.city));
                promises.push(dispatch('UPDATE_INVOICE_COUNTRY', state.user.invoiceAddress.country));
                promises.push(dispatch('UPDATE_INVOICE_POSTAL_CODE', state.user.invoiceAddress.postalCode));
                promises.push(dispatch('UPDATE_INVOICE_PHONE', state.user.invoiceAddress.phone));
                promises.push(dispatch('UPDATE_INVOICE_ADDITIONAL_INFORMATION', state.user.invoiceAddress.additionalInformation));
            }

            if (state.user.requestRegistration) {
                promises.push(dispatch('UPDATE_PASSWORD', state.user.password));
            }

            return Promise.all(promises).then(data => {
                if (getters.hasUserError || !state.selectedCarrier || !state.selectedPayment) {
                    return data;
                }

                return dispatch('UPDATE_ADDRESSES')
                    .then(() => {
                        return data;
                    });
            });
        },
        VALIDATE_WHOLE_FILLED_USER: ({state, dispatch, getters}) => {
            let promises = [];

            if (state.user.deliveryAddress.firstname !== '') {
                promises.push(dispatch('UPDATE_FIRSTNAME', state.user.deliveryAddress.firstname));
            }
            if (state.user.deliveryAddress.lastname !== '') {
                promises.push(dispatch('UPDATE_LASTNAME', state.user.deliveryAddress.lastname));
            }
            if (state.user.deliveryAddress.email !== '') {
                promises.push(dispatch('UPDATE_EMAIL', state.user.deliveryAddress.email));
            }
            if (state.user.deliveryAddress.phone !== '') {
                promises.push(dispatch('UPDATE_PHONE', state.user.deliveryAddress.phone));
            }

            if (state.currentCarrier && state.currentCarrier.pickupInStore === false) {
                if (state.user.deliveryAddress.addressLine1 !== '') {
                    promises.push(dispatch('UPDATE_ADDRESS_LINE_1', state.user.deliveryAddress.addressLine1));
                }
                if (state.user.deliveryAddress.city !== '') {
                    promises.push(dispatch('UPDATE_CITY', state.user.deliveryAddress.city));
                }
                if (state.user.deliveryAddress.country !== '') {
                    promises.push(dispatch('UPDATE_COUNTRY_NO_SYNC', state.user.deliveryAddress.country));
                }
                if (state.user.deliveryAddress.postalCode !== '') {
                    promises.push(dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode));
                }

                if (state.user.showCompanyInformation) {
                    if (state.user.deliveryAddress.company !== '') {
                        promises.push(dispatch('UPDATE_COMPANY', state.user.deliveryAddress.company));
                    }
                    if (state.user.deliveryAddress.identificationNumber !== '') {
                        promises.push(dispatch('UPDATE_IDENTIFICATION_NUMBER', state.user.deliveryAddress.identificationNumber));
                    }
                    if (state.user.deliveryAddress.taxIdentificationNumber !== '') {
                        promises.push(dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber));
                    }
                }
                if (state.user.deliveryAddress.additionalInformation !== '') {
                    promises.push(dispatch('UPDATE_ADDITIONAL_INFORMATION', state.user.deliveryAddress.additionalInformation));
                }
            } else if (!state.currentCarrier) {
                if (state.user.deliveryAddress.addressLine1 !== "") {
                    promises.push(dispatch('UPDATE_ADDRESS_LINE_1', state.user.deliveryAddress.addressLine1));
                }
                if (state.user.deliveryAddress.city !== "") {
                    promises.push(dispatch('UPDATE_CITY', state.user.deliveryAddress.city));
                }
                if (state.user.deliveryAddress.country !== "") {
                    promises.push(dispatch('UPDATE_COUNTRY_NO_SYNC', state.user.deliveryAddress.country));
                }
                if (state.user.deliveryAddress.postalCode !== "") {
                    promises.push(dispatch('UPDATE_POSTAL_CODE', state.user.deliveryAddress.postalCode));
                }
                if (state.user.showCompanyInformation) {
                    if (state.user.deliveryAddress.company !== '') {
                        promises.push(dispatch('UPDATE_COMPANY', state.user.deliveryAddress.company));
                    }
                    if (state.user.deliveryAddress.identificationNumber !== '') {
                        promises.push(dispatch('UPDATE_IDENTIFICATION_NUMBER', state.user.deliveryAddress.identificationNumber));
                    }
                    if (state.user.deliveryAddress.taxIdentificationNumber !== '') {
                        promises.push(dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', state.user.deliveryAddress.taxIdentificationNumber));
                    }
                }

                if (state.user.deliveryAddress.additionalInformation !== '') {
                    promises.push(dispatch('UPDATE_ADDITIONAL_INFORMATION', state.user.deliveryAddress.additionalInformation));
                }
            }

            if (state.user.differentInvoiceAddress) {
                if (state.user.invoiceAddress.firstname !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_FIRSTNAME', state.user.invoiceAddress.firstname));
                }
                if (state.user.invoiceAddress.lastname !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_LASTNAME', state.user.invoiceAddress.lastname));
                }
                if (state.user.invoiceAddress.company !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_COMPANY', state.user.invoiceAddress.company));
                }
                if (state.user.invoiceAddress.identificationNumber !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', state.user.invoiceAddress.identificationNumber));
                }
                if (state.user.invoiceAddress.taxIdentificationNumber !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', state.user.invoiceAddress.taxIdentificationNumber));
                }
                if (state.user.invoiceAddress.addressLine1 !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', state.user.invoiceAddress.addressLine1));
                }
                if (state.user.invoiceAddress.city !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_CITY', state.user.invoiceAddress.city));
                }
                if (state.user.invoiceAddress.country !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_COUNTRY', state.user.invoiceAddress.country));
                }
                if (state.user.invoiceAddress.postalCode !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_POSTAL_CODE', state.user.invoiceAddress.postalCode));
                }
                if (state.user.invoiceAddress.phone !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_PHONE', state.user.invoiceAddress.phone));
                }
                if (state.user.invoiceAddress.additionalInformation !== '') {
                    promises.push(dispatch('UPDATE_INVOICE_ADDITIONAL_INFORMATION', state.user.invoiceAddress.additionalInformation));
                }
            }

            if (state.user.requestRegistration) {
                promises.push(dispatch('UPDATE_PASSWORD', state.user.password));
            }

            return Promise.all(promises).then(data => {
                if (getters.hasUserError || !state.selectedCarrier || !state.selectedPayment) {
                    return data;
                }

                return dispatch('UPDATE_ADDRESSES')
                    .then(() => {
                        return data;
                    });
            });
        },
        UPDATE_ADDRESSES: ({ state, dispatch, commit }) => {
            const formData = new FormData();
            formData.append('user', JSON.stringify(state.user));
            const name = state.currentPayment ? state.currentPayment.name : '';
            const pickupInStore = state.currentCarrier ? state.currentCarrier.pickupInStore : 'false';
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=updateAddresses' + '&payment=' + name + '&pickupInStore=' +  pickupInStore + '&t=' + new Date().getTime(), {
                method: 'POST',
                body: formData,
                credentials: "include"
            }).then(response => {
                return response.json();
            }).then((data) => {
                if (data.result === 'error' && data.type === 'invalid_payment') {
                    commit('SET_USER_INVOICE_COUNTRY_ERROR', data.message)
                }
                return dispatch('LOAD_CARRIERS_AND_PAYMENTS').then(() => {
                    return dispatch('SYNC_STATE');
                });
            });
        },
        UPDATE_TOTAL_PRICE: ({ commit, state }, summary) => {
            let paymentPrice = 0;
            let carrierPrice = 0;
            let productsPrice = 0;
            let paymentPriceWithoutTax = 0;
            let carrierPriceWithoutTax = 0;
            let productsPriceWithoutTax = 0;
            productsPrice = summary.total_price_tax_included;
            productsPriceWithoutTax = summary.total_price_tax_excluded;
            if (state.currentPayment) {
                paymentPrice = state.currentPayment.price;
                paymentPriceWithoutTax = state.currentPayment.priceTaxExcl;
            }
            if (state.currentCarrier) {
                carrierPrice = state.currentCarrier.price;
                carrierPriceWithoutTax = state.currentCarrier.priceTaxExcl;
            }
            let total = parseFloat(paymentPrice) + parseFloat(carrierPrice) + parseFloat(productsPrice);
            let totalWithoutTax = parseFloat(paymentPriceWithoutTax)
                + parseFloat(carrierPriceWithoutTax)
                + parseFloat(productsPriceWithoutTax);

            if (
              parseInt(state.user.deliveryAddress.country) === 37
              && state.currentPayment
              && state.config.cash_payments.includes(state.currentPayment.name)
            ) {
                const totalFull = total * 100;
                const fullRound = Math.round(totalFull / 5) * 5;
                const preTotal = fullRound / 100;
                let rounding = preTotal - total;
                rounding = Math.round(rounding * 100) / 100;
                if (rounding != 0) {
                    fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + rounding, {credentials: "include"})
                      .then((response) => {
                          return response.json();
                      }).then((data) => {
                        commit('SET_ROUNDING_SK', rounding);
                        commit('SET_ROUNDING_FORMATTED', data.result);
                    })
                }else{
                    commit('SET_ROUNDING_SK', 0);
                }
                total = preTotal;
            }
            else if (state.config.rounding > 0) {
                var diff = Math.round(total)-total;
                if (diff != 0.0) {
                    fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + diff, {credentials: "include"})
                        .then((response) => {
                            return response.json();
                        }).then((data) => {
                        commit('SET_ROUNDING', diff);
                        commit('SET_ROUNDING_FORMATTED', data.result);
                    })
                }else{
                    commit('SET_ROUNDING', 0);
                }
                total += diff;
            }else{
                commit('SET_ROUNDING', 0);
                commit('SET_ROUNDING_SK', 0);
            }

            /* TOTAL TAX */
            let carrierTax = 0;
            if (state.currentCarrier) {
                carrierTax = parseFloat(state.currentCarrier.price - state.currentCarrier.priceTaxExcl);
            }
            let paymentTax = 0;
            if (state.currentPayment) {
                paymentTax = parseFloat(state.currentPayment.price - state.currentPayment.priceTaxExcl);
            }
            let totalProductsTax = parseFloat(summary.total_products_tax);
            let totalTax = Math.round((totalProductsTax
              + carrierTax
              + paymentTax) * 100) / 100;
            summary.totalTax = totalTax;

            if(totalTax == 0) {
                totalWithoutTax = total;
            }

            const promises = [
                fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + total, {credentials: "include"})
                  .then((response) => {
                      return response.json();
                  }).then((data) => {
                    summary.formattedPrices.total_price_tax_included = data.result;
                  }),
                fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + totalWithoutTax, {credentials: "include"})
                  .then((response) => {
                      return response.json()
                  }).then((data) => {
                    summary.formattedPrices.total_price_tax_excluded = data.result;
                  }),
                fetch(BASE_URI + ENDPOINTS_FILE + '?action=formatPrice&price=' + totalTax, {credentials: "include"})
                  .then((response) => {
                      return response.json();
                  }).then((data) => {
                    summary.formattedPrices.totalTax = data.result;
                }),
            ];

            Promise.all(promises).then(() => {
                commit('SET_SUMMARY', summary);
            });
        },
        SYNC_SUMMARY: ({ dispatch, commit }) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=getSummary' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then(data => {
                    dispatch('UPDATE_TOTAL_PRICE', data);
                    dispatch('voucher/SET_VOUCHERS', data.vouchers);
                    commit('SET_ADDITIONAL_SHIPPING_COST', { plain: data.additional_shipping_cost, formatted: data.formattedPrices.additional_shipping_cost });
                });
        },
        LOAD_CROSS_SELLING_PRODUCTS: ({ commit }) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=getCrossSellingProducts' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then(data => {
                    commit('SET_CROSSSELLING_PRODUCTS', data);
                });
        },
        SYNC_STATE: ({commit, dispatch, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=loadData' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    let coverSpin = document.getElementById('cart-cover-spin');
                    if (state.initialLoading && coverSpin) {
                        coverSpin.remove();
                    }
                    commit('SET_PRODUCTS', data.products);
                    commit('SET_CROSSSELLING_PRODUCTS', data.crossselling_products);
                    commit('SET_TRANSLATIONS', data.translations);
                    commit('SET_CONFIG', data.config);
                    commit('recyclable/INIT', data.config.recyclable);
                    commit('giftWrapping/INIT', data.config.giftWrapping);
                    commit('dmGlamiConsent/INIT', data.config.modules.dm_glami);
                    commit('dmZboziConsent/INIT', data.config.modules.dm_zbozi);
                    commit('dmHeurekaV2/INIT', data.config.modules.dm_heureka_v2);
                    commit('PdCeneoZaufaneOpiniePro/INIT', data.config.modules.pdceneozaufaneopiniepro);
                    commit('shaimZboziCz/INIT', data.config.modules.shaim_zbozi_cz);
                    commit('mergado/INIT', data.config.modules.mergado);
                    commit('SET_CONTACT', data.contact);
                    commit('SET_CURRENCY', data.config.currency);
                    commit('SAVE_CURRENCY_TO_LOCALSTORAGE');
                    dispatch('SYNC_SUMMARY');
                    commit('SET_FREE_GIFT', data.config.free_gift);
                    commit('SET_ACCESSORIES', data.accessories);
                    commit('SET_RANDOM_PRODUCTS', data.random_products);
                    if (state.initialLoading) {
                        if (data.config.use_default_country) {
                            commit('SET_USER_COUNTRY', data.config.default_country);
                        } else {
                            commit('SET_USER_COUNTRY', '');
                        }
                    }
                    commit('SET_LOGGED_IN', data.config.is_user_logged);
                    commit('SET_INITIAL_LOADING', false);
                    return true;
                })
                .then(() => {
                    CofisCartEvent.dispatch('productsLoaded')
                    if (state.isLoggedIn === true) {
                        return dispatch('LOAD_CUSTOMER_DETAILS');
                    }
                });
        },
        LOAD_PRODUCTS: ({ commit }) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=getProducts' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    commit('SET_PRODUCTS', data);
                    CofisCartEvent.dispatch('productsLoaded')
                });
        },
        SYNC_STATE_FOR_QUANTITY_CHANGE: ({commit, dispatch, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=loadDataForQuantityChange' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then(data => {
                    commit('SET_PRODUCTS', data.products);
                    Event.dispatch('productsLoaded')
                    commit('SET_CONFIG', data.config);
                    commit('SET_CURRENCY', data.config.currency);
                    commit('SAVE_CURRENCY_TO_LOCALSTORAGE');
                    dispatch('SYNC_SUMMARY');
                    commit('SET_FREE_GIFT', data.config.free_gift);
                    if (!state.user.deliveryAddress.country) {
                        commit('SET_USER_COUNTRY', data.config.default_country);
                    }
                })
                .then(() => {
                    dispatch('LOAD_CUSTOMER_DETAILS');
                    dispatch('LOAD_CARRIERS_AND_PAYMENTS');
                });
        },
        LOAD_CARRIERS_AND_PAYMENTS: ({commit, dispatch, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '?action=loadCarriersAndPayments&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    commit('SET_PAYMENT_EXTENSIONS', data.paymentExtensions);
                    commit('SET_CARRIERS', data.carriers);
                    commit('SET_PAYMENT_HOOKS', data.payments);
                    commit('SET_FREE_DELIVERY', data.freeDelivery);
                    commit('SET_PAYMENT_METHOD_THUMBNAILS', data.thumbnails);
                    dispatch('SET_PAYMENTS', data.payments);
                    dispatch('SET_CARRIERS_PAYMENT_MAP', data.map);
                    if (state.carriers.map(item => item.id_carrier).includes(state.selectedCarrier) === false) {
                        commit('SELECT_CARRIER', null);
                        commit('SELECT_PAYMENT', null);
                    } else {
                        commit('SELECT_CARRIER', state.selectedCarrier);
                    }
                    if (state.payments.filter(item => item.active).map(item => item.uniqueName).includes(state.selectedPayment) === false) {
                        commit('SELECT_PAYMENT', null);
                    } else {
                        commit('SELECT_PAYMENT', state.selectedPayment);
                    }
                    // if (state.selectedCarrier === null && state.carriers.length === 1) {
                    //     dispatch('SELECT_CARRIER', state.carriers[0].id_carrier);
                    // }
                    return data;
                });
        },
        LOAD_POST_OFFICES: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadPostOffices' + '&postalCode=' + state.packageForPostOffice.search.postalCode + '&city=' + state.packageForPostOffice.search.city + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_PACKAGE_FOR_POST_OFFICE_POST_OFFICES', data);
                });
        },
        LOAD_DPD_PARCEL_SHOPS: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadDpdParcelShops' + '&query=' + state.dpdParcelShop.search + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_DPD_PARCEL_SHOP_POST_OFFICES', data);
                });
        },
        LOAD_WEDO_PARCEL_SHOPS: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadWedoParcelShops' + '&query=' + state.wedoParcelShop.search + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_WEDO_PARCEL_SHOP_POST_OFFICES', data);
                });
        },
        LOAD_GLS_PARCEL_SHOPS: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadGlsParcelShops' + '&query=' + state.glsParcelShop.search + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_GLS_PARCEL_SHOP_POST_OFFICES', data);
                });
        },
        /* ~start~ SHAIM_BALIKOVNA */
        LOAD_SHAIM_BALIKOVNA: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadShaimBalikovna' + '&query=' + state.shaimBalikovna.search + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_SHAIM_BALIKOVNA_POST_OFFICES', data);
                });
        },
        /* ~end~ SHAIM_BALIKOVNA */
        /* ~start~ SHAIM_BALIKNAPOSTU */
        LOAD_SHAIM_BALIKNAPOSTU: ({commit, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=loadShaimBalikNaPostu' + '&query=' + state.shaimBalikNaPostu.search + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(function (response) {
                    return response.json();
                }).then(function (data) {
                    if (data.error) {
                        alert(data.message);
                        document.getElementById('cart-cover-spin').remove();
                    }

                    commit('SET_SHAIM_BALIKNAPOSTU_POST_OFFICES', data);
                });
        },
        /* ~end~ SHAIM_BALIKNAPOSTU */
        LOAD_CUSTOMER_DETAILS: ({commit, dispatch, state}) => {
            return fetch(BASE_URI + ENDPOINTS_FILE + '/?action=getCustomerDetails' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then(response => response.json())
                .then(data => {
                    if (data.error === true) {
                        return data;
                    }
                    commit('SET_USER_EMAIL', data.email);
                    commit('SET_ADDRESSES', data.addresses);

                    return data
                })
                .then(data => {
                    if (data.error === true) {
                        return data;
                    }
                    if (state.defaultAddressesInitialized === false) {
                        var promises = [];
                        if (data.lastDeliveryAddressId) {
                            commit('SET_DEFAULT_DELIVERY_ADDRESS_ID', data.lastDeliveryAddressId);
                            promises.push(dispatch('UPDATE_DELIVERY_ADDRESS_BY_ID', data.lastDeliveryAddressId));
                        }
                        if (data.lastInvoiceAddressId) {
                            commit('SET_DEFAULT_INVOICE_ADDRESS_ID', data.lastInvoiceAddressId);
                            promises.push(dispatch('UPDATE_INVOICE_ADDRESS_BY_ID', data.lastInvoiceAddressId));
                        }
                        promises.push(dispatch('UPDATE_USER_DIFFERENT_INVOICE_ADDRESS', data.lastDeliveryAddressId !== data.lastInvoiceAddressId))
                        commit('SET_DEFAULT_ADDRESSES_INITIALIZED', true);
                        return Promise.all(promises);
                    } else {
                        return Promise.all([
                            dispatch('UPDATE_DELIVERY_ADDRESS', data.deliveryAddress),
                            dispatch('UPDATE_INVOICE_ADDRESS', data.invoiceAddress)
                        ])
                    }
                })
        },
        FINISH_ORDER: ({commit, dispatch, state, getters}) => {
            let userHasError = function (obj) {
                let result = false;

                Object.entries(obj).forEach(entry => {
                    if (result === true) {
                        return;
                    }
                    if (entry[1] !== null && typeof entry[1] === 'object') {
                        result = userHasError(entry[1]);
                        return;
                    }
                    result = entry[1] !== '';
                });

                return result;
            };
            return dispatch('VALIDATE_WHOLE_USER')
                .then(() => {
                    return new Promise(resolve => {
                        if (userHasError(state.user.errors)) {
                            return resolve('ERROR');
                        }

                        if (state.selectedCarrier && getters.containsVirtualProduct === false) {
                            if (state.currentCarrier.module === 'packetery') {
                                const version = state.currentCarrier.extra.version.replaceAll('.', '');
                                const packeteryId = version >= 213 ? state.packetery_v213.id : state.packetery.id;
                                if (packeteryId === null) {
                                    alert('Vyberte prosím pobočku Zásilkovny');
                                    document.getElementById('cart-cover-spin').remove();
                                    return resolve('ERROR');
                                }
                            }
                        }

                        const requestRegistration = state.user.requestRegistration;

                        const formData = new FormData();

                        formData.append('carrier', state.selectedCarrier);
                        formData.append('payment', state.selectedPayment);
                        formData.append('recyclable', state.recyclable.checked);
                        formData.append('giftWrapping', state.giftWrapping.checked ? '1' : '0');
                        formData.append('giftWrappingMessage', state.giftWrapping.message);
                        formData.append('dmGlami', state.dmGlamiConsent.checked ? '1' : '0');
                        formData.append('dmZbozi', state.dmZboziConsent.checked ? '1' : '0');
                        formData.append('dmHeurekaV2', state.dmHeurekaV2.checked ? '1' : '0');
                        formData.append('pdceneozaufaneopiniepro', state.PdCeneoZaufaneOpiniePro.checked ? '1' : '0');
                        formData.append('pickupDate', state.pickupDate);
                        formData.append('shaimAio_zbozi', state.shaimAio.zbozi ? '1' : '0');
                        formData.append('shaimZboziCz', state.shaimZboziCz.checked ? '1' : '0');
                        formData.append('mergadoArukereso', state.mergado.arukereso.checked ? '1' : '0');

                        const user = state.user;

                        if (state.user.showCompanyInformation === false) {
                            if (!state.config.optional_address_fields.delivery_address.show_company) {
                                user.deliveryAddress.company = '';
                            }
                            user.deliveryAddress.identificationNumber = '';
                            user.deliveryAddress.taxIdentificationNumber = '';
                        }

                        if (state.user.differentInvoiceAddress === false) {
                            user.invoiceAddress.firstname = '';
                            user.invoiceAddress.lastname = '';
                            user.invoiceAddress.phone = '';
                            user.invoiceAddress.addressLine1 = '';
                            user.invoiceAddress.city = '';
                            user.invoiceAddress.country = '';
                            user.invoiceAddress.postalCode = '';
                            user.invoiceAddress.company = '';
                            user.invoiceAddress.identificationNumber = '';
                            user.invoiceAddress.taxIdentificationNumber = '';
                        }

                        formData.append('user', JSON.stringify(user));
                        formData.append('requestRegistration', requestRegistration);
                        formData.append('postOfficeBranch', JSON.stringify(state.packageForPostOffice.selectedPostOffice));
                        formData.append('dpdParcelShop', JSON.stringify(state.dpdParcelShop.selected));
                        formData.append('wedoParcelShop', JSON.stringify(state.wedoParcelShop.selected));
                        formData.append('glsParcelShop', JSON.stringify(state.glsParcelShop.selected));
                        formData.append('shaimBalikovna', JSON.stringify(state.shaimBalikovna.selected));
                        formData.append('shaimBalikNaPostu', JSON.stringify(state.shaimBalikNaPostu.selected));
                        formData.append('consents', JSON.stringify(state.consents));
                        formData.append('note', state.orderNote);

                        return fetch(BASE_URI + ENDPOINTS_FILE + '?action=finishOrder' + '&t=' + new Date().getTime(), {
                            method: 'POST',
                            body: formData,
                            credentials: "include"
                        }).then(response => {
                            return response.json();
                        }).then((result) => {
                            if (result.status === 'error') {
                                resolve(result);
                            } else {
                                resolve(result);
                                if (state.currentPayment.onFinish !== undefined) {
                                    return state.currentPayment.onFinish(result);
                                } else {
                                    const list = document.querySelectorAll('#paymentshooks a');
                                    list[state.currentPayment.index].click();
                                }
                            }
                        }).catch((error) => {
                            alert(state.translations['Error during order processing. Please contact us.']);
                            throw error;
                        });
                    })
                }).catch((error) => {
                    alert(state.translations['Error during order processing. Please contact us.']);
                    throw error;
                })
        },
        UPDATE_DELIVERY_ADDRESS_BY_ID: ({ dispatch, state }, id) => {
            const address = state.user.addresses.filter(item => parseInt(item.id_address) === parseInt(id))[0]

            return dispatch('UPDATE_DELIVERY_ADDRESS', address);

        },
        UPDATE_DELIVERY_ADDRESS: ({ commit, dispatch, state }, data) => {
            const originalCountry = state.user.deliveryAddress.country;
            commit('SET_USER_FIRSTNAME', data.firstname);
            commit('SET_USER_LASTNAME', data.lastname);
            commit('SET_USER_PHONE', data.phone_mobile || data.phone);
            commit('SET_USER_ADDRESS_LINE_1', data.address1);
            commit('SET_USER_CITY', data.city);
            commit('SET_USER_POSTAL_CODE', data.postcode);
            commit('SET_USER_COUNTRY', data.id_country);
            commit('SET_USER_STATE', data.id_state);
            commit('SET_USER_COMPANY', data.company);
            commit('SET_USER_IDENTIFICATION_NUMBER', data.dni);
            commit('SET_USER_TAX_IDENTIFICATION_NUMBER', data.vat_number);

            commit('SET_USER_FIRSTNAME_ERROR', '');
            commit('SET_USER_LASTNAME_ERROR', '');
            commit('SET_USER_PHONE_ERROR', '');
            commit('SET_USER_ADDRESS_LINE_1_ERROR', '');
            commit('SET_USER_CITY_ERROR', '');
            commit('SET_USER_POSTAL_CODE_ERROR', '');
            commit('SET_USER_COUNTRY_ERROR', '');
            commit('SET_USER_COMPANY_ERROR', '');
            commit('SET_USER_IDENTIFICATION_NUMBER_ERROR', '');
            commit('SET_USER_TAX_IDENTIFICATION_NUMBER_ERROR', '');

            commit('SET_DELIVERY_ADDRESS_ID', data.id_address)
            if (parseInt(data.id_country) !== parseInt(originalCountry)) {
                return dispatch('UPDATE_ADDRESSES')
                    .then(() => {
                        return dispatch('LOAD_CARRIERS_AND_PAYMENTS');
                    })
            }

            return new Promise((resolve) => { resolve() });
        },
        UPDATE_INVOICE_ADDRESS_BY_ID: ({ dispatch, state }, id) => {
            const address = state.user.addresses.filter(item => parseInt(item.id_address) === parseInt(id))[0]
            if (!address) {
                return Promise.all([]);
            }

            return dispatch('UPDATE_INVOICE_COUNTRY', address.id_country)
              .then(() => dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', { taxIdentificationNumber: address.vat_number, force: true }))
              .then(() => dispatch('UPDATE_INVOICE_ADDRESS', address));
        },
        UPDATE_INVOICE_ADDRESS: ({ commit }, data) => {
            commit('SET_USER_INVOICE_FIRSTNAME', data.firstname);
            commit('SET_USER_INVOICE_LASTNAME', data.lastname);
            commit('SET_USER_INVOICE_PHONE', data.phone);
            commit('SET_USER_INVOICE_ADDRESS_LINE_1', data.address1);
            commit('SET_USER_INVOICE_CITY', data.city);
            commit('SET_USER_INVOICE_POSTAL_CODE', data.postcode);
            commit('SET_USER_INVOICE_COUNTRY', data.id_country);
            commit('SET_USER_INVOICE_STATE', data.id_state);
            commit('SET_USER_INVOICE_COMPANY', data.company);
            commit('SET_USER_INVOICE_IDENTIFICATION_NUMBER', data.dni);
            commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER', data.vat_number);
            commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE', data.vat_number_state);

            commit('SET_USER_INVOICE_FIRSTNAME_ERROR', '');
            commit('SET_USER_INVOICE_LASTNAME_ERROR', '');
            commit('SET_USER_INVOICE_PHONE_ERROR', '');
            commit('SET_USER_INVOICE_ADDRESS_LINE_1_ERROR', '');
            commit('SET_USER_INVOICE_CITY_ERROR', '');
            commit('SET_USER_INVOICE_POSTAL_CODE_ERROR', '');
            commit('SET_USER_INVOICE_COUNTRY_ERROR', '');
            commit('SET_USER_INVOICE_COMPANY_ERROR', '');
            commit('SET_USER_INVOICE_IDENTIFICATION_NUMBER_ERROR', '');
            commit('SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR', '');

            commit('SET_INVOICE_ADDRESS_ID', data.id_address)
        },
        UPDATE_USER_DIFFERENT_INVOICE_ADDRESS: ({ commit, dispatch, state}, bool) => {
            commit('SET_USER_DIFFERENT_INVOICE_ADDRESS', bool)
            if (bool === true && state.user.defaultInvoiceAddressId > 0) {
                return dispatch('UPDATE_INVOICE_ADDRESS_BY_ID', state.user.defaultInvoiceAddressId)
                    .then(() => {
                        return dispatch('UPDATE_ADDRESSES');
                    })
                    .then(() => {
                        return dispatch('LOAD_CARRIERS_AND_PAYMENTS');
                    })
                    .then(() => {
                        return dispatch('SYNC_SUMMARY');
                    });
            }

            return dispatch('UPDATE_ADDRESSES')
                .then(() => {
                    return dispatch('LOAD_CARRIERS_AND_PAYMENTS');
                })
                .then(() => {
                    return dispatch('SYNC_SUMMARY');
                });
        }
    },
    mutations: {
        SET_TRANSLATIONS: (state, data) => {
            state.translations = data;
        },
        SET_ACTIVE_STEP: (state, data) => {
            state.activeStep = data;
        },
        SET_CONFIG: (state, data) => {
            state.config = data;
        },
        SET_CONTACT: (state, data) => {
            state.contact = data;
        },
        SET_FREE_GIFT: (state, data) => {
            state.freeGift = data;
        },
        SET_ACCESSORIES: (state, data) => {
            state.accessories = data;
        },
        SET_RANDOM_PRODUCTS: (state, data) => {
            state.randomProducts = data;
        },
        /* PRODUCTS */
        SET_PRODUCTS: (state, data) => {
            state.products = data;
        },
        SET_CROSSSELLING_PRODUCTS: (state, data) => {
            state.crossSellingProducts = data;
        },
        /* CARRIERS */
        SET_CARRIERS: (state, data) => {
            state.carriers = data;
        },
        /* CARRIERS */
        SELECT_CARRIER: (state, data) => {
            state.selectedCarrier = data;
            if (state.carriers.length === 0 || state.selectedCarrier === null) {
                state.currentCarrier = null;
                return;
            }
            state.currentCarrier = state.carriers.find(item => item.id_carrier === state.selectedCarrier);
        },
        SET_PACKETERY: (state, data) => {
            state.packetery = data;
        },
        SET_PACKETERY_V213: (state, data) => {
            state.packetery_v213 = data;
        },
        SET_SHAIM_ZASILKOVNA_WIDGET: (state, data) => {
            state.shaim_zasilkovna_widget = data;
        },
        SET_PACKAGE_FOR_POST_OFFICE_SEARCH_POSTAL_CODE: (state, data) => {
            state.packageForPostOffice.search.postalCode = data;
        },
        SET_PACKAGE_FOR_POST_OFFICE_SEARCH_CITY: (state, data) => {
            state.packageForPostOffice.search.city = data;
        },
        SET_PACKAGE_FOR_POST_OFFICE_SELECTED_POST_OFFICE: (state, data) => {
            state.packageForPostOffice.selectedPostOffice.id = data.id;
            state.packageForPostOffice.selectedPostOffice.name = data.name;
        },
        SET_PACKAGE_FOR_POST_OFFICE_POST_OFFICES: (state, data) => {
            state.packageForPostOffice.postOffices = data;
        },

        /* ~start~ SHAIM_DPDPARCELSHOP */
        SET_DPD_PARCEL_SHOP_SEARCH: (state, data) => {
            state.dpdParcelShop.search = data;
        },
        SET_DPD_PARCEL_SHOP_SELECTED_POST_OFFICE: (state, data) => {
            state.dpdParcelShop.selected.id = data.id;
            state.dpdParcelShop.selected.name = data.name;
        },
        SET_DPD_PARCEL_SHOP_POST_OFFICES: (state, data) => {
            state.dpdParcelShop.result = data;
        },
        /* ~end~ SHAIM_PDPPARCELSHOP */

        /* ~start~ SHAIM_INTIME */
        SET_WEDO_PARCEL_SHOP_SEARCH: (state, data) => {
            state.wedoParcelShop.search = data;
        },
        SET_WEDO_PARCEL_SHOP_SELECTED_POST_OFFICE: (state, data) => {
            state.wedoParcelShop.selected.id = data.id;
            state.wedoParcelShop.selected.name = data.name;
        },
        SET_WEDO_PARCEL_SHOP_POST_OFFICES: (state, data) => {
            state.wedoParcelShop.result = data;
        },
        /* ~end~ SHAIM_INTIME */

        /* ~start~ SHAIM_GLSPARCELSHOP */
        SET_GLS_PARCEL_SHOP_SEARCH: (state, data) => {
            state.glsParcelShop.search = data;
        },
        SET_GLS_PARCEL_SHOP_SELECTED_POST_OFFICE: (state, data) => {
            state.glsParcelShop.selected.id = data.id;
            state.glsParcelShop.selected.name = data.name;
        },
        SET_GLS_PARCEL_SHOP_POST_OFFICES: (state, data) => {
            state.glsParcelShop.result = data;
        },
        /* ~end~ SHAIM_GLSPARCELSHOP */

        /* ~start~ SHAIM_BALIKOVNA */
        SET_SHAIM_BALIKOVNA_SEARCH: (state, data) => {
            state.shaimBalikovna.search = data;
        },
        SET_SHAIM_BALIKOVNA_SELECTED_POST_OFFICE: (state, data) => {
            state.shaimBalikovna.selected.id = data.id;
            state.shaimBalikovna.selected.psc = data.psc;
            state.shaimBalikovna.selected.name = data.name;
        },
        SET_SHAIM_BALIKOVNA_POST_OFFICES: (state, data) => {
            state.shaimBalikovna.result = data;
        },
        /* ~end~ SHAIM_BALIKOVNA */

        /* ~start~ SHAIM_BALIKNAPOSTU */
        SET_SHAIM_BALIKNAPOSTU_SEARCH: (state, data) => {
            state.shaimBalikNaPostu.search = data;
        },
        SET_SHAIM_BALIKNAPOSTU_SELECTED_POST_OFFICE: (state, data) => {
            state.shaimBalikNaPostu.selected.id = data.id;
            state.shaimBalikNaPostu.selected.psc = data.psc;
            state.shaimBalikNaPostu.selected.name = data.name;
        },
        SET_SHAIM_BALIKNAPOSTU_POST_OFFICES: (state, data) => {
            state.shaimBalikNaPostu.result = data;
        },
        /* ~end~ SHAIM_BALIKNAPOSTU */

        SET_SHIPMENT_WITH_PAYMENT_PRICE: (state, data) => {
            state.shipmentWithPayment.price = data.price;
            state.shipmentWithPayment.formattedPrice = data.formattedPrice;
        },
        /* PAYMENTS */
        SET_PAYMENTS: (state, html) => {
            const parseName = function (originNode) {
                const node = originNode.cloneNode(true);

                let name = '';
                let paymentModuleNode = null;
                if (node.classList.contains('payment_module')) {
                    paymentModuleNode = node;
                } else {
                    paymentModuleNode = node.querySelector('.payment_module');
                }

                const classes = paymentModuleNode.classList;
                classes.remove('payment_module');
                classes.remove('bootstrap_button');
                if (classes.length === 1) {
                    name = classes[0];
                }

                if (!name && node.querySelector('a').href.indexOf('PrestaAdapter') !== -1) {
                    const binderName = node.querySelector('a').href
                        .replace(state.config.modules_url, '')
                        .replace(new RegExp('(.*)uniModul=(.*?)&(.*)'), '$2');
                    name = binderName + 'Binder';
                }

                if (!name) {
                    name = node.querySelector('a').href
                        .replace(state.config.modules_url, '')
                        .replace(new RegExp('(.*)/(.*)'), '$1');
                }
                if (name === 'klarna_payments') {
                    return 'klarnapaymentsofficial';
                }

                return name;
            }.bind(this);

            const extractGopayExtraPayments = function (nodes) {
                const result = [];
                nodes.forEach(function (node) {
                    if (node.id === 'pms_gopay_extra') {
                        node.childNodes.forEach(function (childNode) {
                            if (childNode.tagName === 'STYLE') {
                                return;
                            }
                            childNode.querySelector('a').title = '';
                            result.push(childNode);
                        });
                    } else {
                        result.push(node);
                    }
                });

                return result;
            }

            const parseMpay24cw = function (node) {
                let name = 'mpay24cw_'+node.querySelector('form').dataset.methodName;
                const el = document.createElement('a');
                el.href = node.dataset.ajaxUrl;
                node.appendChild(el);
                return {
                  name: name,
                  uniqueName: name,
                  title: node.querySelector('.payment-method-name').textContent,
                  description: node.querySelector('.payment-method-description').innerHTML,
                  free: true,
                  img: node.querySelector('.payment-method-name').style.backgroundImage.match(/\"(.*?)\"/)[1],
                  linkElement: el,
                  index: index,
                  onFinish: function (response) {
                      return fetch(node.dataset.ajaxUrl)
                        .then((data) => {
                            return data.json();
                        })
                        .then((data) => {
                            if (data.status === 'success') {
                                eval('('+data.callback+')')();
                            }
                        });
                  },

                }
            }

            const result = [];

            const el = document.createElement('div');
            el.innerHTML = html;
            const payments = el.childNodes;
            const formattedPayments = extractGopayExtraPayments(payments);
            let index = 0;
            formattedPayments.forEach((node) => {
                if (node.dataset && node.dataset.ajaxUrl && /mpay24cw/.test(node.dataset.ajaxUrl)) {
                    let items = parseMpay24cw(node);
                    result.push(items);
                    index++;
                    return;
                }
                if (
                    node.nodeType !== Node.ELEMENT_NODE ||
                    node.tagName === 'STYLE' ||
                    node.tagName === 'SCRIPT' ||
                    node.tagName === 'FORM'
                ) {
                    return;
                }
                if (node.classList.contains('paymentfee') || node.classList.contains('bvkpaymentfee')) {
                    return;
                }
                let name = parseName(node);
                let uniqueName = name + '_' + index;


                const imageNode = node.querySelector('a > img');

                let image = null;

                if (imageNode) {
                    image = imageNode.src;
                }

                const html = document.createElement('div');
                html.appendChild(node.cloneNode(true));

                let title = node.querySelector('a').title;
                if (!title) {
                    title = node.querySelector('a').innerText;
                }
                if (name === 'dm_cashondelivery') {
                    title = title.split('+')[0].trim();
                }
                let paymentObject = {
                    name: name,
                    uniqueName: uniqueName,
                    title: title,
                    description: node.querySelector('a').innerHTML,
                    free: true,
                    img: image,
                    linkElement: node.querySelector('a'),
                    index: index
                };
                if (node.classList.contains('prestapaypalstandard')) {
                    paymentObject.onFinish = function (response) {
                        const formElement = document.createElement('form');
                        formElement.method = 'POST';
                        formElement.action = node.querySelector('a').href;
                        document.body.appendChild(formElement);
                        formElement.submit();
                    }
                }
                result.push(paymentObject);
                index++;
            });

            state.allPayments = result;
            state.paymentHooks = el.innerHTML;
        },
        SET_CARRIERS_PAYMENT_MAP: (state, data) => {
            state.carriersPaymentsMap = data;
        },
        SET_PAYMENT_EXTENSIONS: (state, data) => {
            state.paymentExtensions = data;
        },
        SET_PAYMENT_METHOD_THUMBNAILS: (state, data) => {
            state.paymentMethodThumbnails = data;
        },
        CALCULATE_PAYMENTS: (state) => {
            if (!state.carriersPaymentsMap) {
                return [];
            }
            let availablePayments = [];
            for (let i in state.carriersPaymentsMap) {
                if (state.carriersPaymentsMap.hasOwnProperty(i) === false) {
                    continue;
                }
                for (let j in state.carriersPaymentsMap[i]) {
                    if (state.carriersPaymentsMap[i].hasOwnProperty(j) === false) {
                        continue;
                    }
                    availablePayments.push(state.carriersPaymentsMap[i][j]);
                }
            }
            if (state.selectedCarrier !== null) {
                availablePayments = state.carriersPaymentsMap[state.selectedCarrier];
            }
            state.payments = state.allPayments.map((item) => {
                const newItem = {...item};
                newItem.active = availablePayments.find(aitem => aitem.payment === item.name) !== undefined;
                newItem.price = 0;
                newItem.free = true;
                newItem.priceTaxExcl = 0;
                if (newItem.active) {
                    newItem.price = availablePayments.find(aitem => aitem.payment === item.name).price;
                    newItem.free = availablePayments.find(aitem => aitem.payment === item.name).free;
                    newItem.priceTaxExcl = availablePayments.find(aitem => aitem.payment === item.name).price_without_tax;
                    newItem.formattedPrices = availablePayments.find(aitem => aitem.payment === item.name).formattedPrices;
                }
                return newItem;
            });
            const sortPayments = function (payments) {
                let sorted = [];
                payments.forEach(function (payment) {
                    if (payment.name in state.paymentExtensions) {
                        payment.position = parseInt(state.paymentExtensions[payment.name].position);
                    } else {
                        payment.position = 0;
                    }

                    sorted.push(payment);
                });
                return sorted.sort(function (a, b) {
                    return a.position > b.position ? 1 : -1;
                });
            }
            state.payments = sortPayments(state.payments);
        },
        SELECT_PAYMENT: (state, data) => {
            state.selectedPayment = data;
            if (state.payments.length === 0) {
                state.currentPayment = null;
                return;
            }
            state.currentPayment = state.payments.find(item => item.uniqueName === state.selectedPayment);
        },
        SET_PAYMENT_HOOKS: (state, data) => {
            state.paymentHooks = data;
        },
        SET_FREE_DELIVERY: (state, data) => {
            state.freeDelivery = data;
        },
        SET_SUMMARY: (state, data) => {
            state.summary = data;
        },
        SET_LOGGED_IN: (state, data) => {
            state.isLoggedIn = data;
        },
        /* Login */
        SET_USER_LOGIN_EMAIL_ERROR: (state, data) => {
            state.user.loginErrors.email = data;
        },
        SET_USER_LOGIN_PASSWORD_ERROR: (state, data) => {
            state.user.loginErrors.password = data;
        },
        /* Delivery Address */
        SET_USER_FIRSTNAME: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.firstname = data;
        },
        SET_USER_FIRSTNAME_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.firstname = data;
        },
        SET_USER_LASTNAME: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.lastname = data;
        },
        SET_USER_LASTNAME_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.lastname = data;
        },
        SET_USER_EMAIL: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.email = data;
        },
        SET_USER_EMAIL_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.email = data;
        },
        SET_USER_PASSWORD: (state, data) => {
            state.user.password = data;
        },
        SET_USER_PASSWORD_ERROR: (state, data) => {
            state.user.errors.password = data;
        },
        SET_USER_PHONE: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.phone = data;
        },
        SET_USER_PHONE_PREFIX: (state, data) => {
            state.user.deliveryAddress.phonePrefix = data;
        },
        SET_USER_PHONE_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.phone = data;
        },
        SET_USER_ADDRESS_LINE_1: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.addressLine1 = data;
        },
        SET_USER_ADDRESS_LINE_1_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.addressLine1 = data;
        },
        SET_USER_CITY: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.city = data;
        },
        SET_USER_CITY_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.city = data;
        },
        SET_USER_COUNTRY: (state, data) => {
            state.user.deliveryAddress.country = data;
            if (state.user.invoiceAddress.country === '') {
                state.user.invoiceAddress.country = data
            }
        },
        SET_USER_COUNTRY_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.country = data;
        },
        SET_USER_STATE: (state, data) => {
            state.user.deliveryAddress.state = data;
        },
        SET_USER_POSTAL_CODE: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.postalCode = data;
        },
        SET_USER_POSTAL_CODE_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.postalCode = data;
        },
        SET_USER_SHOW_COMPANY_INFORMATION: (state, data) => {
            if (data === false) {
                state.user.errors.deliveryAddress.company = '';
                state.user.errors.deliveryAddress.identificationNumber = '';
                state.user.errors.deliveryAddress.taxIdentificationNumber = '';
            }
            state.user.showCompanyInformation = data;
        },
        SET_USER_COMPANY: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.company = data;
        },
        SET_USER_COMPANY_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.company = data;
        },
        SET_USER_IDENTIFICATION_NUMBER: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.identificationNumber = data;
        },
        SET_USER_IDENTIFICATION_NUMBER_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.identificationNumber = data;
        },
        SET_USER_TAX_IDENTIFICATION_NUMBER: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.taxIdentificationNumber = data;
        },
        SET_USER_TAX_IDENTIFICATION_NUMBER_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.taxIdentificationNumber = data;
        },
        SET_USER_ADDITIONAL_INFORMATION: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.deliveryAddress.additionalInformation = data;
        },
        SET_USER_ADDITIONAL_INFORMATION_ERROR: (state, data) => {
            state.user.errors.deliveryAddress.additionalInformation = data;
        },
        /* Invoice Address */
        SET_USER_DIFFERENT_INVOICE_ADDRESS: (state, data) => {
            if (data === false) {
                state.user.errors.invoiceAddress = {
                    firstname: '',
                    lastname: '',
                    phone: '',
                    addressLine1: '',
                    city: '',
                    country: '',
                    postalCode: '',
                    company: '',
                    identificationNumber: '',
                    taxIdentificationNumber: '',
                };
            }
            state.user.differentInvoiceAddress = data;

        },
        SET_USER_INVOICE_FIRSTNAME: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.firstname = data;
        },
        SET_USER_INVOICE_FIRSTNAME_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.firstname = data;
        },
        SET_USER_INVOICE_LASTNAME: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.lastname = data;
        },
        SET_USER_INVOICE_LASTNAME_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.lastname = data;
        },
        SET_USER_INVOICE_PHONE: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.phone = data;
        },
        SET_USER_INVOICE_PHONE_PREFIX: (state, data) => {
            state.user.invoiceAddress.phonePrefix = data;
        },
        SET_USER_INVOICE_PHONE_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.phone = data;
        },
        SET_USER_INVOICE_ADDRESS_LINE_1: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.addressLine1 = data;
        },
        SET_USER_INVOICE_ADDRESS_LINE_1_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.addressLine1 = data;
        },
        SET_USER_INVOICE_CITY: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.city = data;
        },
        SET_USER_INVOICE_CITY_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.city = data;
        },
        SET_USER_INVOICE_COUNTRY: (state, data) => {
            state.user.invoiceAddress.country = data;
        },
        SET_USER_INVOICE_COUNTRY_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.country = data;
        },
        SET_USER_INVOICE_STATE: (state, data) => {
            state.user.invoiceAddress.state = data;
        },
        SET_USER_INVOICE_POSTAL_CODE: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.postalCode = data;
        },
        SET_USER_INVOICE_POSTAL_CODE_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.postalCode = data;
        },
        SET_USER_INVOICE_COMPANY: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.company = data;
        },
        SET_USER_INVOICE_COMPANY_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.company = data;
        },
        SET_USER_INVOICE_IDENTIFICATION_NUMBER: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.identificationNumber = data;
        },
        SET_USER_INVOICE_IDENTIFICATION_NUMBER_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.identificationNumber = data;
        },
        SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.taxIdentificationNumber = data;
        },
        SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_STATE: (state, data) => {
            state.user.invoiceAddress.taxIdentificationNumberState = data;
        },
        SET_USER_INVOICE_TAX_IDENTIFICATION_NUMBER_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.taxIdentificationNumber = data;
        },
        SET_USER_INVOICE_ADDITIONAL_INFORMATION: (state, data) => {
            if (data === '-') {
                data = '';
            }
            state.user.invoiceAddress.additionalInformation = data;
        },
        SET_USER_INVOICE_ADDITIONAL_INFORMATION_ERROR: (state, data) => {
            state.user.errors.invoiceAddress.additionalInformation = data;
        },
        SET_USER_NEWSLETTER: (state, data) => {
            state.user.newsletter = data;
        },
        SET_USER_OPTIN: (state, data) => {
            state.user.optin = data;
        },
        SET_USER_REQUEST_REGISTRATION: (state, data) => {
            state.user.requestRegistration = data;
        },
        SET_ORDER_NOTE: (state, data) => {
            state.orderNote = data;
        },
        SET_CURRENCY: (state, data) => {
            state.currency = data;
        },
        SET_CONSENT_TERMS_OF_SERVICE: (state, data) => {
            state.consents.termsOfService = data;
        },
        SET_CONSENT_TERMS_OF_SERVICE_ERROR: (state, data) => {
            state.consents.errors.termsOfService = data;
        },
        SET_CONSENT_PRIVACY_POLICY: (state, data) => {
            state.consents.privacyPolicy = data;
        },
        SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY: (state, data) => {
            state.consents.customerSatisfactionSurvey = data;
        },
        SET_CONSENT_INDEPENDENT_SHOP_RATING: (state, data) => {
            state.consents.independentShopRating = data;
        },
        SET_CONSENT_PS_EMAIL_SUBSCRIPTION: (state, data) => {
            state.consents.psEmailSubscription = data;
        },
        SET_ERROR_LOGIN_COUNTRY_MISMATCH: (state, data) => {
            state.errors.loginCountryMismatch = data;
            if (window.innerWidth < 1200) {
                document.querySelector('.cc-theme__information').scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            } else {
                document.querySelector('.cc-theme').scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        },
        SAVE_CURRENCY_TO_LOCALSTORAGE: (state) => {
            let currency = state.currency;
            localStorage.setItem('currency', currency);
        },
        SET_ADDRESSES: (state, addresses) => {
            state.user.addresses = addresses;
        },
        SET_DELIVERY_ADDRESS_ID: (state, id) => {
            state.user.deliveryAddressId = id;
        },
        SET_INVOICE_ADDRESS_ID: (state, id) => {
            state.user.invoiceAddressId = id;
        },
        SET_DEFAULT_ADDRESSES_INITIALIZED: (state, bool) => {
            state.defaultAddressesInitialized = bool;
        },
        SET_DEFAULT_DELIVERY_ADDRESS_ID: (state, id) => {
            state.user.defaultDeliveryAddressId = id;
        },
        SET_DEFAULT_INVOICE_ADDRESS_ID: (state, id) => {
            state.user.defaultInvoiceAddressId = id;
        },
        SET_INITIAL_LOADING: (state, bool) => {
            state.initialLoading = bool;
        },
        SET_PICKUP_DATE: (state, date) => {
            state.pickupDate = date;
        },
        SET_SHAIM_AIO_ZBOZI: (state, data) => {
            state.shaimAio.zbozi = data;
        },
        SET_ROUNDING: (state, data) => {
            state.rounding = data;
        },
        SET_ROUNDING_SK: (state, data) => {
            state.roundingSK = data;
        },
        SET_ROUNDING_FORMATTED: (state, data) => {
            state.formattedRounding = data;
        },
        SET_ADDITIONAL_SHIPPING_COST: (state, data) => {
            state.additionalShippingCosts = data.plain;
            state.additionalShippingCostsFormatted = data.formatted;
        },
        SET_LOCK_DELIVERY_POSTAL_CODE: (state, data) => {
            state.lockDeliveryPostalCode = data;
        }
    }
});

new Vue({
    render: h => h(App),
    store: store,
    data() {
        return {
            mobile: window.innerWidth < 1350
        };
    },
    mounted() {
        addEventListener('resize', () => {
            this.mobile = innerWidth < 1350;
        });
        if (window.$ && window.$.uniform) {
            $.uniform.defaults.autoHide = false;
        }
        window.onload = () => {
            if (typeof prestashop !== 'undefined' && typeof prestashop.on === 'function') {
                prestashop.on('updateCart',
                  function () {
                      store.dispatch('SYNC_STATE');
                  }
                );
            }
        };
    },
}).$mount('#app');

